var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarMonth24DpE3E3E3Fill0Wght400Grad0Opsz24 = function SvgCalendarMonth24DpE3E3E3Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440-400v-80h80v80zm-160 0v-80h80v80zm320 0v-80h80v80zM440-240v-80h80v80zm-160 0v-80h80v80zm320 0v-80h80v80zM120-80v-720h120v-80h80v80h320v-80h80v80h120v720zm80-80h560v-400H200zm0-480h560v-80H200zm0 0v-80z"
  })));
};
export default SvgCalendarMonth24DpE3E3E3Fill0Wght400Grad0Opsz24;